export default "__VITE_ASSET__Dk9eB13Z__"